// Phoenix
export const EVENT_PHX_HEARTBEAT = 'heartbeat';
export const EVENT_PHX_JOIN = 'phx_join';
export const EVENT_PHX_DOC = 'doc';
export const EVENT_PHX_LEAVE = 'phx_leave';
export const EVENT_PHX_REPLY = 'phx_reply';

// Async Operations
export const EVENT_ASYNC_RESULT = 'async_operation_result';

// Operations
export const EVENT_CREATE = 'create';
export const EVENT_UPDATE = 'update';
export const EVENT_DELETE = 'delete';
export const EVENT_HEAD = 'head';
export const EVENT_INFO = 'info';

// GraphQL subscription data
export const EVENT_SUBSCRIPTION_DATA = 'subscription:data';



// WEBPACK FOOTER //
// ./constants/WsEvents.js